"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWebinars = getWebinars;
exports.getWebinarsSettings = getWebinarsSettings;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'gotowebinar/v1/';

function getWebinars() {
  return _apiClient.default.get(API_BASE + "webinars/future");
}

function getWebinarsSettings() {
  return _apiClient.default.get(API_BASE + "settings");
}